// Click-to-copy for the demo test card shown on the payment step.
//
// Stripe's Payment Element is a cross-origin iframe, so its fields cannot be
// filled from here. Copying is the closest we can get to saving the typing.

export function initDemoCard() {
  const panel = document.querySelector<HTMLElement>('[data-demo-card]');
  if (!panel) return;

  panel.addEventListener('click', async event => {
    const target = (event.target as HTMLElement).closest<HTMLElement>('[data-demo-copy]');
    if (!target) return;

    const value = target.dataset.demoCopy ?? target.textContent ?? '';

    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // Clipboard access can be refused (an insecure origin, or a browser
      // prompt declined). Selecting the text still lets them copy it by hand.
      const range = document.createRange();
      range.selectNodeContents(target);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      return;
    }

    target.classList.add('is-copied');
    window.setTimeout(() => target.classList.remove('is-copied'), 900);
  });
}
